// Pre-refresh screens and components, frozen as of the visual refresh. The
// router renders these when the FI's `enable_sending_ui_refresh` branding
// flag is off (the default). Shared logic (dataContext, api, utils, assets)
// is imported from the live tree; only presentation lives here.
import NavBar from "./components/NavBar";
import SendMoney from "./screens/SendMoney";
import History from "./screens/History/History";
import TransferProcessing from "./screens/TransferProcessing";
import TransferSuccessful from "./screens/TransferSuccessful";
import TransferFailed from "./screens/TransferFailed";
import IncomingDetails from "./screens/IncomingDetails";
import OutgoingDetails from "./screens/OutgoingDetails";
import Settings from "./screens/Settings";
import ScheduledPayments from "./screens/ScheduledPayments";
import ScheduledDetails from "./screens/ScheduledDetails";
import PaymentRequests from "./screens/PaymentRequests";

const legacy = {
  NavBar,
  SendMoney,
  History,
  TransferProcessing,
  TransferSuccessful,
  TransferFailed,
  IncomingDetails,
  OutgoingDetails,
  Settings,
  ScheduledPayments,
  ScheduledDetails,
  PaymentRequests,
};

export default legacy;
